<template>
    <div>
        <div>
            <div>
                <button class="btn btn-default" :class="{ open: this.showDrop }" @click="showDrop = true">
                    <span>Filtrovat</span>
                </button>
            </div>
            <div class="filtered-items">
                <div class="filter-date">Období: {{ this.filterDate }}</div>
                <div v-for="active of activeRegions" :key="active.code">
                    <div class="filter-region">
                        {{ active.country }}
                    </div>
                </div>
                <div v-for="active of activeCompanies" :key="active.id">
                    <div class="filter-company">
                        {{ active.company }}
                    </div>
                </div>
                <div v-if="allFilterItems" class="filter-company">+ {{ this.allFilterItems }}</div>
            </div>
            <a
                class="filter-remove"
                v-if="activeRegions.length > 0 || activeCompanies.length > 0"
                @click="removeFilter()"
            >
                Smazat vše
            </a>
        </div>
        <div v-if="!isFetching" class="filter-options" :class="{ active: showDrop }">
            <div class="filter-wrapper">
                <div class="filter-region-company">
                    <div class="regions-list">
                        <div>
                            <p>země</p>
                        </div>
                        <div class="flex-row">
                            <div>
                                <div
                                    :class="['input-wrapper wrapper-checkbox']"
                                    v-for="(region, i) of regions"
                                    :key="i"
                                >
                                    <input
                                        type="checkbox"
                                        class="input-checkbox region"
                                        name="region"
                                        :id="region.code"
                                        v-on:click="getCheckedRegions"
                                        :checked="region.filtered"
                                    />
                                    <label class="input-label label-checkbox" :for="region.code">
                                        {{ region.country }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="companies-list">
                        <div>
                            <p>instituce</p>
                        </div>
                        <div class="flex-row companies-scroll">
                            <div>
                                <div
                                    :class="['input-wrapper wrapper-checkbox']"
                                    v-for="company of companies"
                                    :key="company.id"
                                >
                                    <input
                                        type="checkbox"
                                        class="input-checkbox"
                                        name="`company`"
                                        :id="`company-${company.id}`"
                                        :value="company.id"
                                        v-on:click="getCheckedCompanies"
                                        :checked="company.filtered"
                                    />
                                    <label class="input-label label-checkbox" :for="`company-${company.id}`">
                                        {{ company.company }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-date">
                    <div>
                        <div>
                            <p>počet událostí za období</p>
                        </div>
                        <label class="container">
                            Posledních 7 dní
                            <input
                                type="radio"
                                name="radio"
                                :checked="this.checkedRadioBtn === 'last-7'"
                                v-on:click="getDateRange(7, 'last-7')"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="container">
                            Posledních 30 dní
                            <input
                                type="radio"
                                name="radio"
                                :checked="this.checkedRadioBtn === 'last-30'"
                                v-on:click="getDateRange(30, 'last-30')"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="container">
                            Posledních 90 dní
                            <input
                                type="radio"
                                name="radio"
                                :checked="this.checkedRadioBtn === 'last-90'"
                                v-on:click="getDateRange(90, 'last-90')"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="container">
                            Celý čas (od 1. 4. 2020)
                            <input
                                type="radio"
                                name="radio"
                                :checked="this.checkedRadioBtn === 'from-the-beginning'"
                                v-on:click="getDateRange('from-the-beginning')"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="container">
                            Vlastní
                            <input
                                type="radio"
                                name="radio"
                                :checked="this.checkedRadioBtn === 'last-own'"
                                v-on:click="getDateRange(0, 'last-own', range.start, range.end), disableFilter"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <v-date-picker
                        v-if="showCalendar"
                        class="calendar"
                        v-model="range"
                        is-range
                        :columns="$screens({ default: 2, xxl: 3 })"
                        :locale="{ id: 'cs', firstDayOfWeek: 2, masks: { weekdays: 'WW' } }"
                        :max-date="new Date()"
                    />
                </div>
            </div>
            <div class="filter-bottom">
                <button class="btn btn-default" @click="applyFilter(), (showDrop = false)" :disabled="isDisabled">
                    <span>Aplikovat filtry</span>
                </button>
                <a class="filter-remove" v-on:click="cancelActualFilter(), (showDrop = false)">Zrušit</a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                isFetching: true,
                showDrop: false,
                showCalendar: false,
                regions: [],
                companies: [],
                filterRegionsAPI: [],
                filterCompaniesAPI: [],
                filterDate: '',
                filterDateDefault: '',
                filterDateFromAPI: '',
                filterDateToAPI: '',
                actualRegionsInFilterRow: 0,
                actualCompaniesInFilterRow: 0,
                maxItemsInFilterRow: 6,
                range: {},
                checkedRadioBtn: 'last-7',
                checkedRadioBtnDefault: '',
                isDisabled: false
            }
        },
        watch: {
            range() {
                this.filterDateToAPI = moment(this.range.end).format('YYYY-MM-DD')
                this.filterDateFromAPI = moment(this.range.start).format('YYYY-MM-DD')

                this.filterDate = `${moment(this.filterDateFromAPI).format('D.M.YYYY')} - ${moment(
                    this.filterDateToAPI
                ).format('D.M.YYYY')}`

                this.disableFilter
            }
        },

        created() {
            this.fetch()

            if (!this.isFetching) {
                let dateFromLocalStorage = window.localStorage.date_from
                let dateToLocalStorage = window.localStorage.date_to

                if (!dateFromLocalStorage && !dateToLocalStorage) {
                    dateFromLocalStorage = moment().add(-7, 'days').format('YYYY-MM-DD')
                    dateToLocalStorage = moment().format('YYYY-MM-DD')
                }

                this.getDateRange('initialData', null, dateFromLocalStorage, dateToLocalStorage)

                this.showMaximumOfCompaniesAndRegions()
            }
        },

        methods: {
            fetch() {
                axios.get('/lists/countries').then((response) => {
                    const regionsLocalStorage = window.localStorage.regions

                    let regionsLocalStorageParsed = []
                    if (regionsLocalStorage) {
                        regionsLocalStorageParsed = JSON.parse(regionsLocalStorage)
                    }

                    for (const region of response.data) {
                        if (region === 'CZ') {
                            const found = regionsLocalStorageParsed.find((x) => x === region)
                            if (found) {
                                this.regions.push({ country: 'Czech Republic', code: region, filtered: true })
                                this.actualRegionsInFilterRow++
                            } else {
                                this.regions.push({ country: 'Czech Republic', code: region, filtered: false })
                            }
                            continue
                        }

                        if (region === 'SK') {
                            const found = regionsLocalStorageParsed.find((x) => x === region)
                            if (found) {
                                this.regions.push({ country: 'Slovakia', code: region, filtered: true })
                                this.actualRegionsInFilterRow++
                            } else {
                                this.regions.push({ country: 'Slovakia', code: region, filtered: false })
                            }
                            continue
                        }

                        if (region === 'DE') {
                            const found = regionsLocalStorageParsed.find((x) => x === region)
                            if (found) {
                                this.regions.push({ country: 'Germany', code: region, filtered: true })
                                this.actualRegionsInFilterRow++
                            } else {
                                this.regions.push({ country: 'Germany', code: region, filtered: false })
                            }
                            continue
                        }
                    }
                })

                axios.get('/lists/institutions').then((response) => {
                    const companiesLocalStorage = window.localStorage.companies

                    let companiesLocalStorageParsed = []
                    if (companiesLocalStorage) {
                        companiesLocalStorageParsed = JSON.parse(companiesLocalStorage)
                    }

                    console.log(companiesLocalStorageParsed)

                    for (const company of response.data) {
                        const foundCompany = companiesLocalStorageParsed.find((x) => x == company.id)

                        if (foundCompany) {
                            this.companies.push({ id: company.id, company: company.name, filtered: true })
                            this.filterCompaniesAPI.push(company.id)
                            this.actualCompaniesInFilterRow++
                        } else {
                            this.companies.push({ id: company.id, company: company.name, filtered: false })
                        }
                    }
                }),
                    (this.isFetching = false)
            },

            getDateRange(value, checkRadio, dateFrom, dateTo) {
                const lastSevenDays = 7
                const lastThirtyDays = 30
                const lastNinetyDays = 90
                const fromTheBeginning = 'from-the-beginning'

                if (value === lastSevenDays || value === lastThirtyDays || value === lastNinetyDays) {
                    this.showCalendar = false
                    this.isDisabled = false
                    this.checkedRadioBtn = checkRadio

                    this.filterDateToAPI = moment().format('YYYY-MM-DD')
                    this.filterDateFromAPI = moment().add(-value, 'days').format('YYYY-MM-DD')

                    this.filterDate = `Posledních ${value} dní`

                    return
                }

                if (value === fromTheBeginning) {
                    this.showCalendar = false
                    this.isDisabled = false
                    this.checkedRadioBtn = fromTheBeginning

                    const firstDateEver = '2020-04-01'

                    this.filterDateToAPI = moment().format('YYYY-MM-DD')
                    this.filterDateFromAPI = firstDateEver

                    this.filterDate = 'Celý čas (od 1. 4. 2020)'

                    return
                }

                if (value === 0) {
                    this.showCalendar = true
                    this.checkedRadioBtn = checkRadio

                    return
                }

                if (value === 'initialData') {
                    this.filterDateFromAPI = dateFrom
                    this.filterDateToAPI = dateTo

                    const firstDateEver = '2020-04-01'
                    const todayString = moment().format('YYYY-MM-DD')

                    const start = moment(dateFrom, 'YYYY-MM-DD')
                    const end = moment(dateTo, 'YYYY-MM-DD')

                    let countDays = Math.round(moment.duration(start.diff(end)).asDays())

                    //because is not negative every time from countDays
                    if (countDays < 0) {
                        countDays = -countDays
                    }

                    if (countDays === lastSevenDays || countDays === lastThirtyDays || countDays === lastNinetyDays) {
                        this.checkedRadioBtn = `last-${countDays}`
                        this.filterDate = `Posledních ${countDays} dní`
                        this.checkedRadioBtnDefault = this.checkedRadioBtn
                        this.filterDateDefault = this.filterDate
                        this.showCalendar = false
                    } else {
                        this.checkedRadioBtn = 'last-own'
                        this.showCalendar = true
                        this.filterDate = `${moment(this.filterDateFromAPI).format('D.M.YYYY')} - ${moment(
                            this.filterDateToAPI
                        ).format('D.M.YYYY')}`
                        this.checkedRadioBtnDefault = this.checkedRadioBtn
                        this.filterDateDefault = this.filterDate

                        this.range.start = this.filterDateFromAPI
                        this.range.end = this.filterDateToAPI
                    }

                    if (start._i === firstDateEver && end._i == todayString) {
                        this.filterDate = 'Celý čas (od 1. 4. 2020)'
                        this.checkedRadioBtn = fromTheBeginning
                        this.checkedRadioBtnDefault = this.checkedRadioBtn
                        this.filterDateDefault = this.filterDate
                        this.showCalendar = false
                    }

                    return
                }
            },

            getCheckedRegions(event) {
                let regionObj = this.regions.find((x) => x.code === event.target.id)
                if (event.target.checked) {
                    this.filterRegionsAPI.push(event.target.id)
                    regionObj.filtered = true
                    this.actualRegionsInFilterRow++
                } else {
                    this.filterRegionsAPI = this.filterRegionsAPI.filter((x) => x !== event.target.id)
                    regionObj.filtered = false
                    if (this.actualRegionsInFilterRow > 0) {
                        this.actualRegionsInFilterRow--
                    }
                }
            },

            getCheckedCompanies(event) {
                let companyObj = this.companies.find((x) => `company-${x.id}` === event.target.id)
                if (event.target.checked) {
                    this.filterCompaniesAPI.push(event.target.value)
                    companyObj.filtered = true
                    this.actualCompaniesInFilterRow++
                } else {
                    this.filterCompaniesAPI = this.filterCompaniesAPI.filter((x) => x != event.target.value)
                    companyObj.filtered = false
                    if (this.actualCompaniesInFilterRow > 0) {
                        this.actualCompaniesInFilterRow--
                    }
                }
            },

            applyFilter() {
                this.checkedRadioBtnDefault = this.checkedRadioBtn
                this.filterDateDefault = this.filterDate

                this.$store.dispatch('reporting/filterData', {
                    institutions: this.filterCompaniesAPI,
                    countries: this.filterRegionsAPI,
                    date_to: this.filterDateToAPI,
                    date_from: this.filterDateFromAPI
                })

                this.removeFromLocalStorage()

                this.saveToLocalStorage('companies', this.filterCompaniesAPI)
                this.saveToLocalStorage('regions', this.filterRegionsAPI)
                this.saveToLocalStorage('date_to', this.filterDateToAPI)
                this.saveToLocalStorage('date_from', this.filterDateFromAPI)
            },

            removeFilter() {
                //set default settings
                this.filterCompaniesAPI = [],
                this.filterRegionsAPI = [],
                this.filterDateToAPI = moment().format('YYYY-MM-DD'),
                this.filterDateFromAPI = moment().add(-7, 'days').format('YYYY-MM-DD')

                this.getDateRange(7, 'last-7')

                 $('.filter-options .input-checkbox:checked').click()

                 this.applyFilter()

            },

            saveToLocalStorage(type, data) {
                if (type === 'date_to' || type === 'date_from') {
                    localStorage.setItem(type, data)
                } else {
                    localStorage.setItem(type, JSON.stringify(data))
                }
            },

            removeFromLocalStorage() {
                localStorage.clear()
            },

            showMaximumOfCompaniesAndRegions() {
                if (screen.width <= 1600) {
                    this.maxItemsInFilterRow = 6
                } else if (screen.width > 1900) {
                    this.maxItemsInFilterRow = 8
                }
            },

            cancelActualFilter() {
                this.checkedRadioBtn = this.checkedRadioBtnDefault
                this.filterDate = this.filterDateDefault
            }
        },

        computed: {
            activeRegions() {
                const computedRegions = this.regions.filter((x) => x.filtered === true)

                return computedRegions
            },

            activeCompanies() {
                const computedCompanies = this.companies.filter((x) => x.filtered === true)
                const computedRegions = this.regions.filter((x) => x.filtered === true)

                const companiesLength = computedCompanies.length + computedRegions.length

                if (companiesLength >= this.maxItemsInFilterRow) {
                    computedCompanies.length = this.maxItemsInFilterRow - computedRegions.length
                }

                return computedCompanies
            },

            allFilterItems() {
                const regionsAndCompanies =
                    this.regions.filter((x) => x.filtered === true).length +
                    this.companies.filter((x) => x.filtered === true).length

                if (regionsAndCompanies <= this.maxItemsInFilterRow) {
                    return null
                }

                return regionsAndCompanies - this.maxItemsInFilterRow
            },

            disableFilter() {
                if (this.showCalendar) {
                    if (Object.keys(this.range).length === 0) {
                        this.isDisabled = true
                    } else {
                        this.isDisabled = false
                    }
                    return
                }
            }
        }
    }
</script>
<style scoped>
    .vc-container {
        font-family: 'Nunito', sans-serif;

        border: none;
        box-shadow: none;

        --blue-200: rgba(89, 55, 183, 0.15);
        --blue-600: #8b65e6;
    }
</style>
